import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import { getInitials } from '@/utils/getInitials';

interface UserAvatarProps {
    name?: string;
    avatarUrl?: string | null;
    className?: string;
    fallbackClassName?: string;
}

/**
 * Foto do usuário logado. A imagem vem do login social e é servida pelo CDN do
 * provedor, então o `referrerPolicy` evita o 403 que o Google devolve quando a
 * requisição carrega referer. Se a URL morrer, o Radix cai sozinho no fallback
 * de iniciais — o mesmo círculo que os logins por e-mail/senha sempre veem.
 */
export function UserAvatar({ name, avatarUrl, className, fallbackClassName }: UserAvatarProps) {
    return (
        <Avatar className={cn('size-9', className)}>
            {avatarUrl && (
                <AvatarImage
                    src={avatarUrl}
                    alt={name ?? ''}
                    className="object-cover"
                    referrerPolicy="no-referrer"
                />
            )}
            <AvatarFallback className="bg-gradient-to-br from-brand-subtle to-accent">
                <span className={cn('text-sm font-semibold text-brand', fallbackClassName)}>
                    {name ? getInitials(name) : 'L'}
                </span>
            </AvatarFallback>
        </Avatar>
    );
}
